import { useSyncWorkspaceIdToPosthog } from '@/hooks/useSyncWorkspaceIdToPosthog';
import { FullPageLoader } from '@heidi/design-system/full-page-loader';
import { type WorkspaceHydrationGatePorts } from '@heidi/workspace';

import { trackWorkspaceShellEvent } from './track-workspace-shell-event';

/**
 * The app half of `@heidi/workspace`'s `WorkspaceHydrationGate`: the app's
 * full-page loader, the workspace-to-PostHog flag sync and the analytics
 * binding. Every member is static, so it is one module-scoped object rather
 * than a hook — the auth mounts take it as a prop and add no hook call.
 */
export const workspaceHydrationGatePorts: WorkspaceHydrationGatePorts = {
  pendingFallback: <FullPageLoader />,
  useSyncHydrationStatus: useSyncWorkspaceIdToPosthog,
  track: trackWorkspaceShellEvent,
};
